module.exports = __webpack_public_path__ + "static/main2-334b890ec97430fe495970ba54ed7b96.png";